module.exports = __webpack_public_path__ + "static/media/3.f57aa310.jpg";